import dataBloedErnstigFactorXa from "../../../../src/data/ernstige-bloedingen-onder-doac-factor-xa.json";
import BasicCollapse from "../../../../src/components/chart/interaction/basic-collapse/Chart.js";
import * as React from 'react';
export default {
  dataBloedErnstigFactorXa,
  BasicCollapse,
  React
};